// Public plan ladder: free(0) → plus(1) → premium(2)
// premium is the next paid tier above plus — reserved, not yet publicly available.
// infinity is internal-only, off the public ladder entirely.
// Legacy DB alias: pro → plus.
const PLAN_RANK = { free: 0, plus: 1, pro: 1, premium: 2, infinity: 99 };

export function isPaidPlan(plan) {
  return (PLAN_RANK[plan] ?? 0) >= 1;
}

// Infinity is a discrete internal plan, not the top of the public ladder — a future
// `premium` tier must never be treated as Infinity-equivalent (rank-based comparison
// here would silently grant it, since PLAN_RANK.premium is also high).
export function isInfinityPlan(plan) {
  return plan === 'infinity';
}

export { PLAN_RANK };
